module.exports = __webpack_public_path__ + "img/black-2.ccc47103.png";